export default {
  box: 'Skrzynka',
  prio: 'Prio',
  comment: 'Komentarz',
};
